/* eslint-disable no-restricted-imports */
import { keccak256, pack } from '@ethersproject/solidity';
import { FACTORY_ADDRESS_MAP, INIT_CODE_HASH } from '@uniswap/v2-sdk';
import { getCreate2Address } from 'ethers/lib/utils';
import { createPlugin } from '../../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue } from '../../../../../Fct/generics';
import { getSupportedTokens } from '../../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESSES } from '../../constants';
import { ETH } from '../../helpers/tokens';
import { amountOutMinRisk } from '../params';
export var RemoveLiquidityETH = createPlugin({
    protocol: 'UNISWAP',
    type: 'ACTION',
    method: 'removeLiquidityETH',
    description: 'Remove liquidity on Uniswap',
    supportedContracts: ROUTER_V2_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'uniswap_router' }),
                // value: new FctValue({ destination: 'wei_amount' }),
                methodParams: {
                    token: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                    liquidity: new FctValue({ destination: 'wei_amount' }),
                    amountTokenMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
                    amountETHMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
                    to: new FctAddress({}),
                    deadline: new FctTimestamp({}),
                },
            },
            output: {
                amountA: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
                amountB: new FctValue({ destination: 'wei_amount', innerIndex: 1 }),
            },
        });
    },
    initParams: {
        methodParams: {
            amountTokenMin: '0',
            amountETHMin: '0',
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
    requiredApprovals: function (params, chainId) {
        var token0 = ETH({ chainId: Number(chainId) || 1 }).address;
        var token1 = params === null || params === void 0 ? void 0 : params.methodParams.token.value;
        var getToken = function () {
            if (token0 && typeof token0 === 'string' && token1 && typeof token1 === 'string') {
                var pairAddress = getCreate2Address(FACTORY_ADDRESS_MAP[Number(chainId)], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH);
                return pairAddress;
            }
            return undefined;
        };
        return [
            {
                to: getToken(),
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.liquidity.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
